import React, { useState } from "react";
import _ from "lodash";

import "./index.css";

const user_icon = require("../../../assets/media/user.png");

const InviteDemoUsersToReview = ({ brandname, users, }) => {

  const copyText = (url)=>{
    navigator.clipboard.writeText(url);
  }
  return (
    <div
      className="modal fade invite_demo_users_to_review"
      id="invite_demo_users_to_review"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content invite_demo_users_to_review-content">
          <div className="modal-header invite_demo_users_to_review-header">
              <h4>Invite demo users to review {brandname}</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div className="modal-body pb-1 invite_demo_users_to_review-body">
            <div className="row">
              <div className="col">
                
                
                <div className="row user-item">
                  <div className="col col-1">Profile</div>
                  <div className="col col-2 user-item-name">Name</div>
                  <div className="col col-8 user-item-name">Link</div>
                </div>
                {users.map((user,index) => (
                  <div key={index} className="row user-item">
                    <div className="col col-1">
                      <img
                        src={user.avatar_url || user_icon}
                        className="user_avatar"
                        alt="icon"
                      />
                    </div>
                    <div className="col col-2 user-item-name">
                      {user.firstname}
                    </div>
                    <div className="col col-7 user-item-link">
                      {`https://reviewrobot.io/${brandname.replace(/\s/g, "")}?uid=${user.id}`}
                    </div>
                    <div className="col col-2 user-item-name">
                      <button  
                          type="button"
                          className="btn btn-sm btn-green setting-field"
                          onClick={()=>copyText(`https://reviewrobot.io/${brandname.replace(/\s/g, "")}?uid=${user.id}`)}
                        >
                            Copy to clipboard
                      </button>
                    </div>
                    
                  </div>
                ))}
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteDemoUsersToReview;



// WEBPACK FOOTER //
// ./src/screens/BespokeReviews/InviteDemoUsersToReview/index.js